import { Paper, Stack, TextField, Typography } from '@mui/material';
import AddressLookup from '../../../components/AddressLookup/AddressLookup';
import { STRINGS } from '../../../constants';
import { StringUtil } from '../../../utils';
import { getCitysprintUkPostcodeError } from '../helpers';

export function CitysprintParcelAddressFields({
  title,
  titleId,
  idPrefix,
  lookupInputId,
  labels,
  address,
  onPatch,
  onAfd,
  disabled = false,
}) {
  const postcodeError = getCitysprintUkPostcodeError(address.postcode);

  const idFor = field => `${idPrefix}-${field}`;
  const nameFor = field =>
    `${idPrefix}${StringUtil.capitalizeFirstLetters(field)}`;

  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
      role='region'
      aria-labelledby={titleId}
    >
      <Typography variant='h3' component='h2' id={titleId} sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Stack spacing={2}>
        <AddressLookup
          autocompleteInputId={lookupInputId}
          addressKey={address.addressId}
          countryISO={STRINGS.GB}
          onChange={onAfd}
          variant='outlined'
          fullWidth
          shouldClearOnChange
          disabled={disabled}
        />
        <TextField
          fullWidth
          required
          id={idFor('postcode')}
          name={nameFor('postcode')}
          label={labels.postcode}
          value={address.postcode}
          onChange={e =>
            onPatch({
              postcode: StringUtil.removeWhitespacesAndSymbols(e.target.value),
            })
          }
          error={Boolean(postcodeError)}
          helperText={postcodeError ?? undefined}
          slotProps={{ htmlInput: { maxLength: 8 } }}
          autoComplete='postal-code'
          variant='outlined'
          disabled={disabled}
        />
        <TextField
          fullWidth
          id={idFor('organisation')}
          name={nameFor('organisation')}
          label={labels.organisation}
          value={address.organisation}
          onChange={e => onPatch({ organisation: e.target.value })}
          slotProps={{ htmlInput: { maxLength: 35 } }}
          autoComplete='organization'
          disabled={disabled}
        />
        <TextField
          fullWidth
          required
          id={idFor('street')}
          name={nameFor('street')}
          label={labels.street}
          value={address.street}
          onChange={e => onPatch({ street: e.target.value })}
          slotProps={{ htmlInput: { maxLength: 35 } }}
          autoComplete='address-line1'
          disabled={disabled}
        />
        <TextField
          fullWidth
          id={idFor('locality')}
          name={nameFor('locality')}
          label={labels.locality}
          value={address.locality}
          onChange={e => onPatch({ locality: e.target.value })}
          slotProps={{ htmlInput: { maxLength: 35 } }}
          autoComplete='address-line2'
          disabled={disabled}
        />
        <TextField
          fullWidth
          required
          id={idFor('town')}
          name={nameFor('town')}
          label={labels.town}
          value={address.town}
          onChange={e => onPatch({ town: e.target.value })}
          slotProps={{ htmlInput: { maxLength: 35 } }}
          autoComplete='address-level2'
          disabled={disabled}
        />
        <TextField
          fullWidth
          id={idFor('county')}
          name={nameFor('county')}
          label={labels.county}
          value={address.county}
          onChange={e => onPatch({ county: e.target.value })}
          slotProps={{ htmlInput: { maxLength: 35 } }}
          disabled={disabled}
        />
      </Stack>
    </Paper>
  );
}
